import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import RelatedExceptionListOverview from './RelatedExceptionListOverview'
import RelatedExceptionBankFailureFraud from './RelatedExceptionBankFailureFraud'
import RelatedExceptionOnlineLoanFraud from './RelatedExceptionOnlineLoanFraud'
import RelatedExceptionUnusualBehavior from './RelatedExceptionUnusualBehavior'

interface RelatedExceptionListProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function RelatedExceptionList({ data, title, sectionIndex }: RelatedExceptionListProps) {
  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <RelatedExceptionListOverview data={data} />
      <RelatedExceptionBankFailureFraud data={data} />
      <RelatedExceptionOnlineLoanFraud data={data} />
      <RelatedExceptionUnusualBehavior data={data} />
    </ReportWrapper>
  )
}
